import FTLStopHelpers from '@/utilities/FTLStopHelpers';

export const getNonSkippedStops = (stops) => {
    return stops.filter((s) => s.type !== 'LUNCH' && !(s.overnight && FTLStopHelpers.isWarehousePickup(s)));
};
